import React from 'react';
import ReactDOM from 'react-dom';
import DashApp from './dashApp';
import { unregister } from './registerServiceWorker';
import 'antd/dist/antd.css';
import { configureAppMessages } from './helpers/configureAppMessages';

configureAppMessages();

// Handle chunk loading failures
let hasReloaded = false;
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  
  // Check if it's a chunk loading error
  if (error && (
    (error.message && error.message.includes('Loading chunk')) ||
    (error.message && error.message.includes('Loading CSS chunk')) ||
    (error.message && error.message.includes('ChunkLoadError')) ||
    error.name === 'ChunkLoadError'
  )) {
    console.warn('Chunk loading failed, attempting to reload page:', error.message);
    
    // Only reload once to prevent infinite reload loops
    if (!hasReloaded) {
      hasReloaded = true;
      window.location.reload();
    }
  }
});

ReactDOM.render(<DashApp />, document.getElementById('root'));

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./dashApp.js', () => {
    const NextApp = require('./dashApp').default;
    ReactDOM.render(<NextApp />, document.getElementById('root'));
  });
}
// No service-worker.js is shipped with this build; unregister any stale workers.
unregister();
